var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.classes,
    attrs: {
      "href": _vm.to,
      "target": _vm.target
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b184a906","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Link/Link.vue
// module id = 473
// module chunks = 0